import { useState } from 'react';
import { Button, Radio, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import ApiService from '../../core/service/api-service';

// Red nedeni kullanıcıya bırakılır: dcm4chee, aynı görüntüler cihazdan tekrar gönderildiğinde ne
// yapacağına bu nedene bakarak karar verir (dcmAcceptPreviousRejectedInstance). Politika metinleri
// dcm4chee varsayılan kurulumunu anlatır; backend yalnız bu dört kodu kabul eder.
const REJECTION_REASONS = [
    { code: '113001', title: 'REJECT_QUALITY', policy: 'REJECT_QUALITY_POLICY' },
    { code: '113037', title: 'REJECT_PATIENT_SAFETY', policy: 'REJECT_PATIENT_SAFETY_POLICY' },
    { code: '113038', title: 'REJECT_WRONG_WORKLIST', policy: 'REJECT_WRONG_WORKLIST_POLICY' },
    { code: '113039', title: 'REJECT_RETENTION_EXPIRED', policy: 'REJECT_RETENTION_EXPIRED_POLICY' },
];

export default function SeriesRejectModal({ studyId, series, onRejected, onCancel }) {
    const { t } = useTranslation();
    const [code, setCode] = useState(null);
    const [loading, setLoading] = useState(false);

    const reject = async () => {
        setLoading(true);
        try {
            const res = await ApiService.Dicom.RejectSeries(studyId, series.seriesInstanceUID, code);
            if (res.success) {
                onRejected && onRejected();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '16px 0' }}>
            <Typography.Paragraph>
                <b>{series.seriesNumber} — {series.desc || '-'}</b>{' '}
                <Typography.Text type="secondary">
                    ({series.modality}, {t('Instance')}: {series.instanceCount})
                </Typography.Text>
            </Typography.Paragraph>

            <Typography.Paragraph type="secondary">
                {t('REJECT_SERIES_DESC')}
            </Typography.Paragraph>

            <Typography.Text strong>{t('Rejection Reason')}</Typography.Text>
            <Radio.Group
                value={code}
                onChange={(e) => setCode(e.target.value)}
                style={{ width: '100%', marginTop: 8 }}
            >
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    {REJECTION_REASONS.map((reason) => (
                        <Radio key={reason.code} value={reason.code}>
                            <div>
                                <b>{t(reason.title)}</b>{' '}
                                <Typography.Text type="secondary">({reason.code})</Typography.Text>
                            </div>
                            <div style={{ fontSize: 12 }}>{t(reason.policy)}</div>
                        </Radio>
                    ))}
                </Space>
            </Radio.Group>

            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Space>
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    <Button
                        type="primary"
                        danger
                        loading={loading}
                        disabled={!code}
                        onClick={reject}
                    >
                        {t('Reject Series')}
                    </Button>
                </Space>
            </div>
        </div>
    );
}
